const normalizeApiBaseUrl = (value) => {
    if (!value) {
        return value;
    }
    return value.endsWith('/') ? value.slice(0, -1) : value;
};

const getApiBaseUrl = () => {
    const baked = process.env.REACT_APP_API_BASE_URL;

    // Browser: prefer same-origin /api when the build baked a different host (VPS IP vs domain).
    if (typeof window !== 'undefined') {
        if (baked && baked.startsWith('/')) {
            return normalizeApiBaseUrl(baked);
        }
        if (baked) {
            try {
                const apiHost = new URL(baked).hostname;
                if (apiHost !== window.location.hostname) {
                    return '/api';
                }
                return normalizeApiBaseUrl(baked);
            } catch {
                return '/api';
            }
        }
        return '/api';
    }

    if (baked) {
        return normalizeApiBaseUrl(baked);
    }
    if (process.env.NODE_ENV === 'development') {
        return '/api';
    }
    if (process.env.NODE_ENV === 'production' && !baked) {
        console.error(
            '[config] REACT_APP_API_BASE_URL is missing. Set it in Render (or PSA_API_RENDER_URL in render-build-frontend.sh).'
        );
    }
    return '/api';
};

const config = {
    get apiBaseUrl() {
        return getApiBaseUrl();
    },
    roles: {
        ADMIN: 'admin',
        PROJECT_MANAGER: 'project_manager',
        TEAM_LEADER: 'team_leader',
        EMPLOYEE: 'employee'
    },
    projectStatuses: {
        PLANNING: 'planning',
        ACTIVE: 'active',
        ON_HOLD: 'on_hold',
        COMPLETED: 'completed',
        CANCELLED: 'cancelled'
    },
    taskStatuses: {
        NOT_STARTED: 'not_started',
        IN_PROGRESS: 'in_progress',
        COMPLETED: 'completed',
        BLOCKED: 'blocked'
    },
    taskPriorities: {
        LOW: 'low',
        MEDIUM: 'medium',
        HIGH: 'high',
        URGENT: 'urgent'
    }
};

export default config;
